module.exports = __webpack_public_path__ + "img/22.4.NH3-N.8904df1f.png";